"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Signature = exports.Address = void 0;
class Address {
    constructor(value) {
        this.value = value;
    }
    bech32() {
        return this.value;
    }
}
exports.Address = Address;
class Signature {
    constructor(buffer) {
        this.buffer = buffer;
    }
    static fromHex(hex) {
        return new Signature(Buffer.from(hex, "hex"));
    }
    hex() {
        return this.buffer.toString("hex");
    }
}
exports.Signature = Signature;
//# sourceMappingURL=primitives.js.map